module.exports = __webpack_public_path__ + "img/vipTipRow.bc43e4a5.png";